<template>
  <div class="d-flex p-3 header-navbar">
    <div class="justify-content-start col-9 col-sm-9 fantasy-header">
      <img :src="require(`../brand/${brandConfig}/assets/score-predictor-header.png`)">
    </div>
    <div class="d-flex justify-content-end col-3 settings-menu-icons ">
      <img @click="settingsIconClicked" src="../assets/game/settings-gear-wheel.png">
      <div  v-if="menuIconVisible"  @click="menuIconCLicked">
        <img src="../assets/game/menu-icon.png">
      </div>
      <div v-if="!menuIconVisible" @click="menuIconCLicked" class="w3 center w3-animate-top" >
        <img src="../assets/game/header-cancel-icon.png" >
      </div>
    </div>
  </div>
  <transition name="slide-burger-menu" >
    <div v-if="showMenu">
      <SidebarMenu/>
    </div>
  </transition>
</template>

<script>
import SidebarMenu from "../components/SidebarMenu";
import {mapState} from "vuex";

export default {
  name: "Header",
  components: {SidebarMenu},
  data() {
    return {
      showMenu: false,
      menuIconVisible: true,
    }
  },
  computed: {
    ...mapState(['brandConfig'])
  },
  methods: {
    menuIconCLicked() {
      this.showMenu = !this.showMenu;
      this.menuIconVisible =!this.menuIconVisible;
    },
    settingsIconClicked() {
      this.$router.push('/settings');
    },
  },
  watch:{
    $route (to, from){
      if (this.$route.path === '/how-to-play' || this.$route.path === '/prizes' ) {
        this.menuIconVisible = true
        this.showMenu = false;
      }
    }
  }
}
</script>

<style scoped>

.header-navbar {
  background-color: #ffffff;
}

.fantasy-header img {
  margin-left: 15px;
  width: 220px;
}

.settings-menu-icons img {
  margin-right: 15px;
  height: 30px;
  width: 30px;
}

.slide-burger-menu-leave-active, .slide-burger-menu-enter-active {
  transition: 1s;
  z-index: 5;
}

.slide-burger-menu-enter-from {
  transform: translate(-100%, 0);
}

.slide-burger-menu-leave-to {
  transform: translate(-100%, 0);
}


</style>
